(function ($) {
	'use strict'; // Global Vars

	const $document = $(document);

	const scheduleSettings = {
		// days: [2, 3, 4, 5, 6, 0, 1],
		startTime: '0:00',
		endTime: '24:00',
		interval: 60
	};

	const cfAdminConditions = {

		init: function init() {
			cfAdminConditions.initObjects();
			cfAdminConditions.clickEvents();
			cfAdminConditions.changeEvents();
			cfAdminConditions.submitEvents();
			cfAdminConditions.updateHelperText();
			cfAdminConditions.updateHeadingText();
			$('#cf_cc_condition_metabox .inside').fadeIn();
		},

		submitEvents: function submitEvents() {
			$('.post-type-cf_cc_condition #post').on('submit', function () {
				// Updating all the schedule data with their correspond hidden input
				$('.date-time-schedule').each(function () {
					var $elem = $(this);
					var $parent = $elem.parent();
					var scheduleInput = $parent.find('.schedule-input');
					scheduleInput.val(JSON.stringify($elem.data('artsy.dayScheduleSelector').serialize()));
				});
			});
		},

		changeEvents: function changeEvents() {
			$document.on('change', '.rule-wrap select', function () {
				var $select = $(this);
				var $selectedOption = $select.find(':selected');
				var $adminWrapper = $('.admin-conditions-wrap');
				var $triggerData = $selectedOption.data('show-fields');

				if (typeof $triggerData !== 'undefined') {
					var $triggerDataClasses = $triggerData.replace(/\|/g, ' ');


					if ($select.hasClass('second-level-selection')) {
						var $selectionContainer = $select.closest('.second-level-selection-container');
						$selectionContainer.attr('class', 'cf-cc-form-group second-level-selection-container').addClass($triggerDataClasses);
					}

					$adminWrapper.attr('class', 'admin-conditions-wrap').addClass($triggerDataClasses);

					$('#hidden_stored_selection_classes').val($triggerDataClasses);
				}
			});

			$document.on('change click', '.cf-cc-autocomplete-opener', function () {
				var $this = $(this);
				var effectRate = 250;
				var $currentShownElem = $('.cf-cc-geo-selected');
				var classNameOfElemToShow;
				var $elemToShow;
				$currentShownElem.stop(true).slideUp(effectRate);
				$currentShownElem.removeClass('cf-cc-geo-selected'); // Handle new element

				classNameOfElemToShow = $this.data('open');
				$elemToShow = $('.' + classNameOfElemToShow);
				$elemToShow.addClass('cf-cc-geo-selected');
				$elemToShow.stop(true).slideDown(effectRate);
			});
		},

		clickEvents: function clickEvents() {
			$document.on('click', '.conditional-tabs .tab', function () {
				let correspondingSelect = $(this).data('trigger');
				if (typeof correspondingSelect !== 'undefined') {
					$('.conditional-tabs').attr('class', 'conditional-tabs').addClass(correspondingSelect);
					$('.trigger-type').val(correspondingSelect).trigger('change');
					$('#dxptk-new-rule-type').trigger('ruleChange');
				}
			});

			$document.on('click', '.settimeinstructions .closeX', function () {
				// write cookie to the client in order to prevent re-displaying of the info box
				cfAdminConditions.createCookie('set_time_instructions', true, 712); // 712 days - 2 years
				// remove the box from the view
				$(this).closest('.set-time-info-container').remove();
			});

			$('#dxptk-new-rule-type').on('click', function () {
				const $tabs = $('.conditional-tabs');
				if (1 === $tabs[0].classList.length) {
					return;
				}
				$('.admin-conditions-wrap').attr('class', 'admin-conditions-wrap');
				$tabs.attr('class', 'conditional-tabs');
				$('.trigger-type').val('');
				let $heading = $('h1.wp-heading-inline');
				const textArray = $heading.text().split(" ");
				$heading.html(textArray[0] + ' Persona Rule');
				cfAdminConditions.updateHelperText();
			})
		},

		initObjects: function initObjects() {
			$('.post-type-cf_cc_condition #post').attr('novalidate', 'novalidate');

			$('.date-time-schedule').dayScheduleSelector(scheduleSettings); // Enable DateTimePicker

			$('.cfdatetimepicker').cfdatetimepicker(); // set custom Add New link active

			if (window.location.href.indexOf('post-new.php?post_type=cf_cc_condition') > -1) {
				$('a[href="' + window.location.href + '"]').closest('li').addClass('current');
			}

			$('#dxptk-new-rule-type').on('ruleChange', function () {
				cfAdminConditions.updateHelperText();
				cfAdminConditions.updateHeadingText();
			});
		},
		updateHeadingText: function updateHeadingText() {
			const $selectedRule = $('.trigger-type').val();
			if (!$selectedRule) {
				return;
			}
			const $ruleType = $('.conditional-tabs .tab[data-trigger="' + $selectedRule + '"]').text();
			let $heading = $('h1.wp-heading-inline');
			const textArray = $heading.text().split(" ");
			$heading.html(textArray[0] + ' <b>' + $ruleType + '</b> Persona Rule');
		},
		// Reset helper text
		updateHelperText: function updateHelperText() {
			const $type = $('#dxptk-new-rule-type');
			const $config = $('#dxptk-configure-new-rule');
			const $selectedRule = $('.trigger-type').val();
			if ($selectedRule) {
				$type.html(cfAdminConditions.backArrow + ' Start Over');
				$type.css({'cursor': 'pointer'});
				$config.text('Configure your persona rule');
				$('.conditional-tabs .tab[data-trigger="' + $selectedRule + '"]').siblings().css({
					'max-height': '0',
					'padding-top': '0',
					'padding-bottom': '0'
				});
			} else {
				$type.text('Select a rule type');
				$type.css({'cursor': 'auto'});
				$config.text('Pick a rule type to get started');
				$('.conditional-tabs .tab').css({
					'max-height': '500px',
					'padding-top': '15px',
					'padding-bottom': '15px'
				});

			}

		},

		backArrow: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26.676 26.676" xml:space="preserve"><defs><linearGradient id="gradient" x1="0.86" y1="0.85" x2="0.14" y2="0.15"> <stop offset="0%" stop-color="#4b1cdd"/> <stop offset="23.33%" stop-color="#9618bb"/> <stop offset="70%" stop-color="#e415a0"/> <stop offset="80%" stop-color="#e51986"/> <stop offset="100%" stop-color="#e71c1c"/> </linearGradient></defs><g><path style="fill:url(#gradient)" d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562C26.18,21.891,26.141,21.891,26.105,21.891z"/></g></svg>',

		// Create cookie
		createCookie: function createCookie(name, value, days) {
			var expires;
			var date;

			if (days) {
				date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = '; expires=' + date.toGMTString();
			} else {
				expires = '';
			}

			document.cookie = name + '=' + value + expires + '; path=/';
		}
	};

	$document.ready(function () {
		cfAdminConditions.init();
	});
})(jQuery);
